import { logoAmerinode, logoFaviconStoom, logoMiniAmerinode, logoMiniStoom, logoSecondaryStoom, logoStoom } from "utils/logos";

const useIsStoomHostname = () => {
  const isStoom: boolean = window.location.hostname.includes('lass');

  const companyHolderName = isStoom ? 'Stoom' : 'Amerinode'

  const mainDocumentTitle = `${companyHolderName} - Locker Manager`

  const logoToRender: string = isStoom ? logoStoom : logoAmerinode;
  const logoSecondaryToRender: string = isStoom ? logoSecondaryStoom : logoAmerinode;
  const logoMiniToRender: string = isStoom ? logoMiniStoom : logoMiniAmerinode;
  const logoFaviconToRender: string = isStoom ? logoFaviconStoom : logoMiniAmerinode;

  return {
    isStoom,
    mainDocumentTitle,
    companyHolderName,
    logoToRender,
    logoSecondaryToRender,
    logoMiniToRender,
    logoFaviconToRender,
  }
};

export default useIsStoomHostname;
